import React, { Component } from 'react';
import * as $ from 'jquery';
import SuccessDialog from './SuccessDialog.js';
import TicketAddition from './TicketAddition.js';
import Tickets from './Tickets.js';
import axios from 'axios';
import { MENU } from '../Sidebar.js';
import { translate } from 'react-i18next';

export const PRIORITY = {
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3
};

export const STATUS = {
  OPEN: 1,
  CLOSED: 2
};

let cancelToken;
let state;
let tokenSession;

class TicketsContainer extends Component {

  constructor(props) {
    super(props);
    if (tokenSession !== props.getTokenSession()) {
      state = this.getInitState();
    }
    this.state = state;
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
  }

  componentDidMount() {
    this.setModalListener();
    this.reload();
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
    state = this.state;
    tokenSession = this.props.getTokenSession();
  }

  addTicket = (params) => {
    this.props.post(
      "/addTicket",
      params,
      (response) => this.didAddTicket(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  clearCategories = () => {
    this.setState({
      categories: [],
      category_id: ""
    });
  }

  clearDepartments = () => {
    this.setState({
      department_id: "",
    });
  }

  clearManagers = () => {
    this.setState({
      manager_id: "",
      managers: []
    });
  }

  clearTypes = () => {
    this.setState({
      type_id: "",
      types: []
    });
  }

  didAddTicket = () => {
    $('#btnSuccess').click();
  }

  didChangeCategory = () => {
    this.clearTypes();
  }

  didChangeCenter = () => {
    this.clearCategories();
    this.clearDepartments();
    this.clearManagers();
    this.clearTypes();
  }

  didChangeDepartment = () => {
    this.clearCategories();
    this.clearManagers();
    this.clearTypes();
  }

  didGetCategories = (response) => {
    this.setState({ categories: response });
  }

  didGetCenters = (response) => {
    this.setState({ centers: response });

    this.handleOptionUpdate();
  }

  didGetDepartments = (response) => {
    this.setState({ departments: response });
  }

  didGetManagers = (response) => {
    this.setState({ managers: response });
  }

  didGetTickets = (response) => {
    this.setState({ tickets: response });
  }

  didGetTypes = (response) => {
    this.setState({ types: response });
  }

  getCategories = (params) => {
    this.props.post(
      "/getTicketCategories",
      params,
      (response) => this.didGetCategories(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  getCenters = (params) => {
    this.props.post(
      "/getCenters",
      params,
      (response) => this.didGetCenters(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  handleOptionUpdate = () => {
    if($("#center-results").children().length){
      $("#center-results").css("display", "");
    }else{
      $("#center-results").css("display", "none");
    }
  }

  getDepartments = (params) => {
    this.props.post(
      "/getDepartments",
      params,
      (response) => this.didGetDepartments(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  getInitState = () => {
    return {
      categories: [],
      category_id: "",
      center: this.props.user.center_id,
      centerQuery: this.props.user.center_name,
      centers: [],
      department_id: "",
      departments: [],
      description: "",
      manager_id: "",
      managers: [],
      priority: PRIORITY.LOW,
      tickets: [],
      type_id: "",
      types: [],
    };
  }

  getManagers = (params) => {
    this.props.post(
      "/getManagers",
      params,
      (response) => this.didGetManagers(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  getTickets = (params) => {
    this.props.post(
      "/getTickets",
      params,
      (response) => this.didGetTickets(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  getTypes = (params) => {
    this.props.post(
      "/getTicketTypes",
      params,
      (response) => this.didGetTypes(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  handleCategoryChange = (event) => {
    const getTypes = () => this.getTypes({
      category_id: this.state.category_id,
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });

    this.didChangeCategory();
    
    this.setState({
      category_id: event.target.value
    }, getTypes);
  }

  handleCenterClick = (center) => {
    this.didChangeCenter();

    this.setState({
      center: center.id,
      centerQuery: center.name
    });
  }

  handleCenterSearch = (event) => {
    const getCenters = () => this.getCenters({
      query: this.state.centerQuery,
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });

    this.didChangeCenter();

    this.setState({
      center: null,
      centerQuery: event.target.value
    }, getCenters);
  }

  handleDepartmentChange = (event) => {
    const callback = () => {
      this.getCategories({
        department_id: this.state.department_id,
        token_id: this.props.getTokenId(),
        token_session: this.props.getTokenSession()
      });
      
      this.getManagers({
        center_id: this.state.center,
        department_id: this.state.department_id,
        token_id: this.props.getTokenId(),
        token_session: this.props.getTokenSession()
      });
    }

    this.didChangeDepartment();

    this.setState({
      department_id: event.target.value
    }, callback);
  }

  handleDescriptionChange = (event) => {
    this.setState({ description: event.target.value });
  }

  handleManagerChange = (event) => {
    this.setState({ manager_id: event.target.value });
  }

  handlePriorityChange = (event) => {
    this.setState({ priority: Number(event.target.value) });
  }

  handleTicketSubmit = (event) => {
    event.preventDefault();
    this.addTicket({
      category_id: this.state.category_id,
      center_id: this.state.center,
      department_id: this.state.department_id,
      description: this.state.description,
      manager_id: this.state.manager_id,
      priority: this.state.priority,
      type_id: this.state.type_id,
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
  }

  handleTypeChange = (event) => {
    this.setState({ type_id: event.target.value });
  }

  reload = () => {
    this.getTickets({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
    this.getDepartments({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
  }

  setModalListener = () => {
    $('#modalSuccess').on('hidden.bs.modal', () => {
      this.setState(Object.assign(
        {},
        this.getInitState(),
        { tickets: this.state.tickets }
      ));
      this.reload();
    });
  }

  renderSuccessDialog = () => {
    return(
      <SuccessDialog />
    );
  }

  renderTicketAddition = () => {
    return(
      <TicketAddition
        categories={this.state.categories}
        category_id={this.state.category_id}
        center={this.state.center}
        centers={this.state.centers}
        centerQuery={this.state.centerQuery}
        department_id={this.state.department_id}
        departments={this.state.departments}
        description={this.state.description}
        handleCategoryChange={this.handleCategoryChange}
        handleCenterClick={this.handleCenterClick}
        handleCenterSearch={this.handleCenterSearch}
        handleDepartmentChange={this.handleDepartmentChange}
        handleDescriptionChange={this.handleDescriptionChange}
        handleManagerChange={this.handleManagerChange}
        handlePriorityChange={this.handlePriorityChange}
        handleTicketSubmit={this.handleTicketSubmit}
        handleTypeChange={this.handleTypeChange}
        manager_id={this.state.manager_id}
        managers={this.state.managers}
        priority={this.state.priority}
        type_id={this.state.type_id}
        types={this.state.types} />
    );
  }

  renderTickets = () => {
    return(
      <Tickets tickets={this.state.tickets} />
    );
  }

  render() {
    const { t } = this.props;
    const permissionStatus = this.props.getPermissionStatus(MENU.TICKETS);

    return(
      <div>
        <h2 className="page-header">{t('dashboard.tickets.heading')}</h2>
        {permissionStatus && <div className="jumbotron alert-warning">{permissionStatus}</div>}
        {!permissionStatus &&
          <div>
            {this.renderTicketAddition()}
            {this.renderTickets()}
            {this.renderSuccessDialog()}
          </div>
        }
      </div>
    );
  }
}

export default translate('common')(TicketsContainer);



// WEBPACK FOOTER //
// ./src/dashboard/tickets/TicketsContainer.js